var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Nextgrid", {
    attrs: {
      "and-conditional-model": {
        CashCardTypeIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
      },
      apiurl: "VisionNextFinance/api/CashCard/Search",
      OrderByColumns: [
        { column: "DocumentDate", orderByType: 0 },
        { column: "RecordId", orderByType: 0 }
      ]
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04a32d4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a32d4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CashCard/index.vue
// module id = null
// module chunks = 